export default {
  header: "My Viewnotfound Page",
  view: "Viewnotfound"
};
